import axios from "axios";
import { formatDistance } from "date-fns";

import { analytics, postApiSegment } from "../../Analytics";

const { REACT_APP_S3_CLIP_BUCKET } = process.env;

export const dateFormatWithDistanceSuffix = (createdDate: string) => {
  try {
    const date = /^\d+$/.test(createdDate)
      ? parseInt(createdDate)
      : createdDate;
    return formatDistance(new Date(date), new Date(), {
      addSuffix: true,
    });
  } catch (_) {
    return "";
  }
};

export function getClipTitle(clip: any) {
  if (!clip) return;
  if (clip?.userClipTitle) {
    return `${clip.userClipTitle}`;
  }
  if (clip?.clipTitle && clip?.clipTitle !== "") {
    return `${clip?.clipTitle}`;
  } else {
    return `${clip?.clipTitleSuffix}`;
  }
}
export const isVideoUrl = (url: string): boolean => {
  if (!url) return false;

  const videoExtensions = [".mp4", ".webm", ".ogg", ".mov"];
  return videoExtensions.some((ext) => url.toLowerCase().includes(ext));
};
export const CLIP_STATUS = {
  DELETED: "Deleted",
  PROCESSED: "Processed",
  INACTIVE: "Inactive",
  SUBMITTED: "Submitted",
};

export function formatNumber(num: any, lowerBoundary = 10000) {
  if (!num) return "0";

  if (num < 1000) return num.toLocaleString();

  if (num < 1000000) {
    if (num < lowerBoundary) return num.toLocaleString(); // show full number under boundary
    return `${+(num / 1000).toFixed(1)}K`;
  }

  if (num < 1000000000) {
    return `${+(num / 1000000).toFixed(2)}M`;
  }

  return `${+(num / 1000000000).toFixed(2)}B`;
}

export const clipHasStudio = (clip: any) =>
  clip?.personalizations?.cards?.length > 0 || clip?.studio?.length > 0;

export function getDisplayName(clip: any) {
  const displayName = clip.username || clip.steamHandle;
  return displayName || "Allstar User";
}

export const canRemix = (clip: any, isAdmin = false) => {
  if (clip?.partner?.useCase === "SH" || clip?.partner?.useCase === "MH")
    return false;
  if (![101, 407].includes(clip.game) && !clip.isMontage) return true;
  if (isAdmin) return true;
  return clip.isRemixable;
};

export const countClipImpression = (shareId: string, isMontage = false) => {
  axios
    .post(`${process.env.REACT_APP_AWS_SERVERLESS}/clips/views`, {
      shareId,
      isClip: !isMontage,
    })
    .catch(() => {});
};

export const getMapThumbnail = (
  map: string | undefined,
  randomize: boolean = false,
) => {
  const mapNumber = randomize ? Math.round(Math.random()) + 1 : 1;
  const THUMBNAIL_URL = `${REACT_APP_S3_CLIP_BUCKET}/static/clip-map-thumbs`;
  const mapName = map?.replace(/[\s\d]+/, "").toLowerCase();
  return `${THUMBNAIL_URL}/${mapName}_${mapNumber}.webp`;
};

export const isObjectId = (id: string): boolean => {
  return /^[0-9a-fA-F]{24}$/.test(id);
};

export const extractFileNameFromUrl = (url: string): string => {
  if (!url) return "";
  try {
    const urlObj = new URL(url);
    const pathname = urlObj.pathname;
    const filename = pathname.split("/").pop() || "";
    const cleanFilename = filename.split("?")[0].split("#")[0];
    const lastDotIndex = cleanFilename.lastIndexOf(".");
    return lastDotIndex > 0
      ? cleanFilename.substring(0, lastDotIndex)
      : cleanFilename;
  } catch (error) {
    return "";
  }
};

const CLIP_CDN = "mediacdn.allstar.gg";

export const isValidCDNUrl = (url: string): boolean => {
  if (!url) return false;

  return [process.env.REACT_APP_S3_CLIP_BUCKET || "", CLIP_CDN]
    .filter((domain) => domain)
    .some((domain) => url.includes(domain));
};
